/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharereviewreject2Inputs */

const en_sharereviewreject2 = /** @type {(inputs: Sharereviewreject2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reject`)
};

const de_sharereviewreject2 = /** @type {(inputs: Sharereviewreject2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ablehnen`)
};

/**
* | output |
* | --- |
* | "Reject" |
*
* @param {Sharereviewreject2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharereviewreject2 = /** @type {((inputs?: Sharereviewreject2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharereviewreject2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharereviewreject2(inputs)
	return de_sharereviewreject2(inputs)
});
export { sharereviewreject2 as "shareReviewReject" }